import { render, staticRenderFns } from "./vue-multiselect.html?vue&type=template&id=0e311d5f&scoped=true&external"
import script from "./vue-multiselect.js?vue&type=script&lang=js&external"
export * from "./vue-multiselect.js?vue&type=script&lang=js&external"
import style0 from "./vue-multiselect.scss?vue&type=style&index=0&id=0e311d5f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e311d5f",
  null
  
)

export default component.exports